module.exports = __webpack_public_path__ + "b69b78b05ec113d3b2bb55f2f6fd9e2e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/up-31.png
// module id = 2644
// module chunks = 0